import React from "react";

import styles from "./PageHeader.module.css";

function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <header className={styles.Wrap}>
      {eyebrow && <div className={styles.Eyebrow}>{eyebrow}</div>}
      <h1 className={styles.Title}>{title}</h1>
      {subtitle && <p className={styles.Subtitle}>{subtitle}</p>}
    </header>
  );
}

export default PageHeader;
